import { fetchWithAuthRetry } from './apiUtils';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api';

export async function generateAltText(
  imageData: string,
  mimeType: string
): Promise<string> {
  const response = await fetchWithAuthRetry(`${API_BASE_URL}/ai/images/describe`, {
    method: 'POST',
    body: JSON.stringify({ imageBase64: imageData, mimeType }),
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(
      (body as { message?: string }).message || `Failed to generate alt text: ${response.statusText}`
    );
  }

  const result = (await response.json()) as { altText: string };
  return result.altText;
}
